import AuthCallbackReceiver from "../../features/auth/callbackReceiver";
import ForgotPassword from "../../features/login/forgot-password/forgotPassword";
import PODInformationSummary from "../../features/pod-information/podInformationSummary";
import ResetPassword from "../../features/login/reset-password/resetPassword";
import RollDetails from "../../features/roll-details/rollDetails";
import UserProfile from "../data/user/UserProfile";
import { AddFreightExceptionPaths } from "../../features/exceptions/route";
import { AddFreightExceptions } from "../../features/exceptions/addFreightExceptions";
import { AppointmentSummary } from "../../features/appointment/appointmentsSummary";
import { DeliveryReceipts } from "../../features/delivery-receipts/deliveryReceipts";
import { EnterPODInformation } from "../../features/pod-information/enter-pod-information/enterPodInformation";
import { ExactFreightList } from "../../features/exact-freight/exactFreightList";
import { InboundFreight } from "../../features/inbound-freight/inboundFreight";
import { ResetPasswordPath } from "../../features/login/reset-password/route";
import { RollDetailsPath } from "../../features/roll-details/route";
import { SelectFreightException } from "../../features/exceptions/selectFreightException";
import { ShipmentDetails } from "../../features/shipments/shipmentDetails/shipmentDetails";
import { ShipmentDetailsPath } from "../../features/shipments/shipmentDetails/route";
import { Tracking } from "../../features/tracking/tracking";
import { UpdateLoadManifest } from "../../features/inbound-freight/update-load-manifest/updateLoadManifest";
import { UpdateLoadManifestPath } from "../../features/inbound-freight/route";
import ImpersonateCallbackReceiver from "../../features/auth/impersonateReceiver";

export const accountNumberParamName = "accountNumber";

export const xgsRoutes = {
  home: "/",
  forgotPassword: "/forgot-password",
  shipments: {
    tracking: "/shipments",
    podInformation: "/pod",
    enterPodInformation: "/pod/new",
    deliveryReceipts: "/delivery-receipts"
  },
  freightExceptions: {
    addFreightException: "/freight-exception",
    listing: "/freight-exceptions"
  },
  exactFreight: {
    listing: "/live-freight"
  },
  freightAppointments: {
    summary: "/appointments"
  },
  inboundFreight: {
    listing: "/inbound-freight",
    rollDetails: "/inbound-freight/roll-details",
    updateLoadManifest: "/inbound-freight/update-load-manifest"
  },
  users: {
    resetPassword: "/users/reset-password",
  },
  authCallback: "/auth-callback",
  impersonateCallback: "/impersonate"
};

export interface RoutesComponent {
  path: string;
  component: React.FC<any>;
  fixedPath?: string;
  isPrivate?: boolean;
}

export interface CorePathParams {
  [accountNumberParamName]: string;
}

export const getPathWithCoreParams = (route: string) => {
  return `/:${accountNumberParamName}${route === xgsRoutes.home ? "" : route}`;
};

export const getPathWithAccountNumber = (route: string) => {
  const paths = [getPathWithCoreParams(route), route];
  return paths;
};

export const publicRoutesComponents: RoutesComponent[] = [
  {
    path: xgsRoutes.authCallback,
    component: AuthCallbackReceiver
  },
  {
    path: xgsRoutes.forgotPassword,
    component: ForgotPassword
  },
  {
    fixedPath: xgsRoutes.users.resetPassword,
    path: `${xgsRoutes.users.resetPassword}/:${ResetPasswordPath.token}`,
    component: ResetPassword
  },
  {
    path: `${xgsRoutes.impersonateCallback}`,
    component: ImpersonateCallbackReceiver,
    isPrivate: false
  }
];

const agentRoutesComponents: RoutesComponent[] = [
  {
    path: xgsRoutes.home,
    component: Tracking,
    isPrivate: true
  },
  {
    path: xgsRoutes.shipments.tracking,
    component: Tracking,
    isPrivate: true
  },
  {
    path: `${xgsRoutes.shipments.tracking}/:${ShipmentDetailsPath.invoiceNumber}`,
    component: ShipmentDetails,
    isPrivate: true
  },
  {
    path: xgsRoutes.shipments.deliveryReceipts,
    component: DeliveryReceipts,
    isPrivate: true
  },
  {
    path: `${xgsRoutes.shipments.podInformation}`,
    component: PODInformationSummary,
    isPrivate: true
  },
  {
    path: xgsRoutes.shipments.enterPodInformation,
    component: EnterPODInformation,
    isPrivate: true
  },
  {
    path: xgsRoutes.freightExceptions.addFreightException,
    component: SelectFreightException,
    isPrivate: true
  },
  {
    path: `${xgsRoutes.freightExceptions.addFreightException}/:${AddFreightExceptionPaths.invoiceNumber}`,
    component: AddFreightExceptions,
    isPrivate: true
  },
  {
    path: xgsRoutes.exactFreight.listing,
    component: ExactFreightList,
    isPrivate: true
  },
  {
    path: `${xgsRoutes.exactFreight.listing}/:${ShipmentDetailsPath.invoiceNumber}`,
    component: ShipmentDetails,
    isPrivate: true
  },
  {
    path: `${xgsRoutes.freightAppointments.summary}`,
    component: AppointmentSummary,
    isPrivate: true
  },
  {
    path: xgsRoutes.inboundFreight.listing,
    component: InboundFreight,
    isPrivate: true
  },
  {
    path: `${xgsRoutes.inboundFreight.rollDetails}/:${RollDetailsPath.manifestNumber}`,
    component: RollDetails,
    isPrivate: true
  },
  {
    path: `${xgsRoutes.inboundFreight.updateLoadManifest}/:${UpdateLoadManifestPath.manifestNumber}`,
    component: UpdateLoadManifest,
    isPrivate: true
  }
];

export const getRouteConfig = (user: UserProfile | null | undefined) => {
  if (!user) return [];
  return agentRoutesComponents;
};
